import { api, assetUrl } from './api.config'

export type AssetType = {
    id: string
    name: string
}

export interface LiveUser {
    id: number
    name: string
    username: string
    email: string
}

export type ResourceGroup = {
    id: number
    name: string
    assetTypes: AssetType[]
    liveUserIds: number[]
}

export const getResourceGroup = async (resourceGroupId: number): Promise<ResourceGroup> => {
    return fetch(`${assetUrl}${api.resourceGroup.resourceGroup}/${resourceGroupId}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else if (fetchData.status === 404) {
                return undefined
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(() => {
            throw new Error()
        })
}


export const getResourceGroups = async (params?: IQueryParamsList): Promise<ResourceGroup[]> => {
    const queryString = new URLSearchParams({
        sortBy: params.orderBy,
        sortByDirection: params.direction
    }).toString()

    return fetch(`${assetUrl}${api.resourceGroup.resourceGroup}/?${queryString}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const updateResourceGroup = async (body: ResourceGroup): Promise<ResourceGroup> => {
    const data = await fetch(`${assetUrl}${api.resourceGroup.resourceGroup}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}

export const deleteResourceGroup = async (body: number): Promise<void> => {
    const data = await fetch(`${assetUrl}${api.resourceGroup.resourceGroup}/${body}/`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createResourceGroup = async (body: ResourceGroup): Promise<ResourceGroup> => {
    const data = await fetch(`${assetUrl}${api.resourceGroup.resourceGroup}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}
